//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'cmFooter',
  props: {
      active: {
        type: Number,
        default: 0
      },
  },
  data () {
    return {
      nav:[
        {
          key:0,
          title:'首页',
          path:'/',
          auth:'home',
          img:'/static/images/home.png',
          imged:'/static/images/homeed.png',
        },
        {
          key:3,
          title:'物流',
          path:'/driver',
          auth:'driver',
          img:'/static/images/driver.png',
          imged:'/static/images/drivered.png',
        },
         {
          key:4,
          title:'加工厂',
          path:'/factory',
          auth:'factory',
          img:'/static/images/factory.png',
          imged:'/static/images/factoryed.png',
        },
        //  {
        //   key:5,
        //   title:'承包商',
        //   path:'/factoryContractor',
        //   auth:'factoryContractor',
        //   img:'/static/images/factory.png',
        //   imged:'/static/images/factoryed.png',
        // },
        //  {
        //   key:6,
        //   title:'窗帘调度',
        //   path:'/curtain',
        //   auth:'curtain',
        //   img:'/static/images/curtain.png',
        //   imged:'/static/images/curtained.png',
        // },
        // {
        //   key:1,
        //   title:'工单',
        //   path:'/work',
        //   auth:'work',
        //   img:'/static/images/work.png',
        //   imged:'/static/images/worked.png',
        // },
        {
          key:2,
          title:'我的',
          path:'/user',
          auth:'user',
          img:'/static/images/me.png',
          imged:'/static/images/meed.png',
        },
      ]
    }
  },
   created(){
    let grade = parseInt(this.$func.getLocal('grade'));

  },
}



// WEBPACK FOOTER //
// ./src/components/cmFooter.vue